import * as yup from "yup";

import {
  IDownloadAccountStatement,
  TStatementDocumentType,
  TStatementKind,
} from "./AccountStatement";
import { statementTargets } from "../../../enums";

export const accountStatementValidationSchema: yup.SchemaOf<IDownloadAccountStatement> =
  yup
    .object({
      // actual transfer details
      start_date: yup.string().required("start period is required"),
      end_date: yup.string().required("end period is required"),
      currency: yup.string().required("Currency is required"),
      display_payouts: yup.boolean().required(),
      emails: yup
        .array()
        .of(
          yup
            .object()
            .shape({
              email: yup.string().email("Please enter a valid email"), //.required(),
            })
            .nullable()
            .optional()
        )
        .when("target", {
          is: (target: statementTargets) => target === statementTargets.email,
          then: yup
            .array()
            .of(
              yup
                .object()
                .shape({
                  email: yup
                    .string()
                    .email("Please enter a valid email")
                    .required("Please enter a value for the email"),
                })
                .required("Please enter a valid email")
            )
            .required("Emails are required when target is emails"),
          otherwise: yup.array(),
        })
        .test(
          "duplicate-email-check",
          "Duplicate emails detected",
          (emailArray) => {
            if (!emailArray) return true;
            let emailSet = new Set(emailArray.map((entry) => entry.email));
            return emailSet.size === emailArray.length;
          }
        ),

      statementKind: yup
        .mixed<TStatementKind>()
        // .oneOf(Object.values(TStatementKind))
        .required("statementKind is required"),
      target: yup
        .mixed<statementTargets>()
        .oneOf(Object.values(statementTargets))
        .required("statementTarget is required"),
      // includePayoutsInCollectionsStatement: yup
      //   .boolean()
      //   .required("includePayoutsInCollectionsStatement is required"),
      statementDocumentType: yup
        .mixed<TStatementDocumentType>()
        // .oneOf(Object.values(TStatementDocumentType))
        .required("statementDocumentType is required"),
    })
    .required();
